<template lang="pug">
.field
    validation-provider(:name="field.title" :rules="rules" v-slot="{ errors }")
        .control(v-if="type === 'textarea'")
            textarea.textarea(:placeholder="field.title" type="textarea" v-model="innerValue" :class="{ 'is-danger': errors && errors.length }")
        .control(v-else-if="['select', 'multi-select'].includes(type)")
            // :allow-empty="!required"
            multiselect(
                v-model="innerValue"
                :class="{ 'is-danger': errors && errors.length }"
                :multiple="type === 'multi-select'"
                :options="options"
                track-by="key"
                label="value"
                placeholder="auswählen..."
                deselect-label=""
                selected-label="ausgewählt"
                select-label="mit Enter auswählen"
            )
        .control.upload(v-else-if="type === 'upload'")
            vue-dropzone(
                :class="{ disabled: innerValue.length >= maxFiles, 'is-danger': errors && errors.length }"
                ref="dropzone"
                id="new-file"
                :options="dropzoneOptions"
                :use-font-awesome="true"
                :auto-process-queue="true"
                :upload-multiple="true"
                :use-custom-slot="true"
                @vdropzone-sending="newFileSending"
                @vdropzone-sending-multiple="newFileSending"
                @vdropzone-success="newFileUploaded"
                @vdropzone-error="newFileUploadFailed"
            )
                .dropzone-custom-field
                    i.fas.fa-cloud-upload-alt
                    h4.is-size-4.dropzone-custom-title Dateien hierher bewegen
                .subtitle oder
                    span.href hier klicken
            ul.file-list(v-if="innerValue && innerValue.length")
                li(v-for="file in innerValue" :key="file.id")
                    label {{ file.name }}
                    button.button.is-danger.is-small.is-rounded(@click.prevent="removeFile(file)")
                        i.fas.fa-trash-alt
        .control(v-else :class="icon ? ['has-icons-left', 'has-icons-right'] : ''")
            input.input(:placeholder="field.title" :type="type" v-model="innerValue" :class="{ 'is-danger': errors && errors.length }")
            //span.icon.is-small.is-left(v-if="icon")
                i.fas(:class="icon")
        p.help.text-red-700(v-if="errors && errors.length") {{ errors[0] }}
        //p.help.text-grey-dark.text-xs.italic(v-else-if="required") Pflichtfeld
</template>

<script>
import { findIndex } from 'lodash';
import Multiselect from 'vue-multiselect';
import VueDropzone from 'vue2-dropzone';
import store from '@/store';

export default {
    name: 'FormField',
    components: {
        VueDropzone,
        Multiselect
    },
    data() {
        let innerValue = '';
        if (['multi-select', 'upload'].includes(this.field.type)) innerValue = [];

        const maxFiles = 3;
        return {
            innerValue,
            maxFiles,
            dropzoneOptions: {
                url: store.state.setup.uploadEndpoint,
                // url: 'http://127.0.0.1/store/images',
                // addRemoveLinks: true,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf,.zip,.xls,.xlsx,.csv',
                maxFiles,
                maxFilesize: 2,
                previewTemplate: this.previewTemplate(),
                timeout: 6 * 60 * 1000 // 6 minutes
            }
        };
    },
    props: {
        field: {
            type: Object,
            required: true
        },
        // must be included in props
        value: {
            type: null
        }
    },
    watch: {
        // Handles internal model changes.
        innerValue(value) {
            this.$emit('input', value);
        },
        // Handles external model changes.
        value(value) {
            this.innerValue = value;
        }
    },
    computed: {
        settings() {
            return this.field.settings || [];
        },
        options() {
            let options = [];
            const setting = this.settings.find(el => el.key === 'select-options');
            if (setting && setting.options && setting.options.length) options = setting.options;
            return options;
        },
        type() {
            let type = 'text';
            let setting;
            switch (this.field.key) {
                case 'user-email':
                    type = 'email';
                    break;

                default:
                    setting = this.settings.find(el => el.key === 'type');
                    if (setting) type = setting.value;
            }

            return type;
        },
        icon() {
            let icon;
            switch (this.field.key) {
                case 'user-name':
                    icon = 'fa-user';
                    break;

                case 'user-email':
                    icon = 'fa-at';
                    break;
            }
            return icon;
        },
        required() {
            let value = false;
            const setting = this.settings.find(el => el.key === 'required');
            if (setting && setting.value) value = setting.value;
            return ['true', '1', 'yes', true].includes(value) || ['user-name', 'user-email'].includes(this.field.key);
        },
        rules() {
            let rules = [];
            if (this.required) rules.push('required');
            if (this.field.key === 'user-email') rules.push('email');
            return rules.join('|');
        }
    },
    methods: {
        // emitChange(){
        //     let value = {
        //         'id': this.field.id,
        //         'title': this.field.title,
        //         'value': this.additionalFieldData,
        //         'type': this.field.sub_title
        //     }
        //     this.$emit('valueChanged', value)
        // },
        previewTemplate() {
            return `
                <div class="dz-preview dz-file-preview">
                    <div class="dz-filename">
                        <span data-dz-name></span>
                    </div>
                    <div class="dz-size" data-dz-size></div>
                    <div class="dz-thumbnail">
                        <img data-dz-thumbnail />
                    </div>
                    <div class="dz-progress">
                        <span class="dz-upload" data-dz-uploadprogress></span>
                    </div>
                    <div class="dz-success-mark">
                        <i class="fas fa-check"></i>
                    </div>
                    <div class="dz-error-mark">
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="dz-error-message">
                        <span data-dz-errormessage></span>
                    </div>
                </div>
            `;
        },
        newFileSending(file, xhr, formData) {
            formData.append('context[type]', 'form-entry-attachment');
            xhr.ontimeout = e => console.log('Server Timeout: ' + e);
        },
        newFileUploaded(upload, response) {
            this.$refs.dropzone.removeFile(upload);

            let image = response;
            image.upload = true;

            delete image.hash;

            const srcToFile = (src, name, type) => {
                return fetch(src)
                    .then(res => res.arrayBuffer())
                    .then(buf => new File([buf], name, { type }));
            };

            let file = {};
            srcToFile(upload.dataURL, upload.name, upload.type).then(result => {
                // file = result
                // file.src = `${storageRoute}/${table}/${response.id}/${response.name}` // ?token=${localStorage.getItem('member-token')}
                console.log(result);
                file.id = response.id;
                file.name = response.name;
                file.upload = true;

                if (this.innerValue.length < this.maxFiles) {
                    this.innerValue.push(file);
                    this.$refs.dropzone.options.maxFiles = this.maxFiles - this.innerValue.length;
                }
            });
        },
        newFileUploadFailed(file) {
            setTimeout(() => {
                this.$refs.dropzone.removeFile(file);
            }, 2000);
        },
        // updateAdditionalFieldData(data){
        //     this.additionalFieldData.push(data)
        // },
        removeFile(file) {
            const index = findIndex(this.innerValue, ['id', file.id]);
            this.innerValue.splice(index, 1);
            // this.$refs.dropzone.removeFile(data)
        }
    },
    created() {
        if (this.value) {
            this.innerValue = this.value;
        }
    }
};
</script>
<style lang="sass" scoped>
.upload
  width: 100%
  & > .column
    padding-top: 0
    padding-bottom: 0
.file-list
    list-style: none
    margin-left: 0
    li
        display: flex
        justify-content: space-between
        button.is-rounded
            width: 27px
.field
    margin-bottom: 1rem

span.href:before
    content: ' '
</style>
